import { gql } from '@apollo/client';
export const ADD_PAYMENT_CONFIG = gql`
  mutation addPaymentConfig($paymentConfig: PaymentConfigInput) {
    addPaymentConfig(paymentConfig: $paymentConfig)
  }
`;
